import { useState } from 'react'
import Styles from './MediaFromLinkDrawer.module.scss'
import { MediaFromLinkDrawerProps } from './Types'
import { Drawer } from 'components/Drawer'
import { PasteLink } from './PasteLink'
import { PreviewFile } from './PreviewFile'

type CurrentStep = 'pasteLink' | 'preview'

export const MediaFromLinkDrawer = (props: MediaFromLinkDrawerProps) => {
  const { accept, onUse, ...rest } = props
  const [currentStep, setCurrentStep] = useState<CurrentStep>('pasteLink')
  const [url, setUrl] = useState<string>('')
  const [file, setFile] = useState<File>()

  const onBack = () => {
    setCurrentStep('pasteLink')
    setFile(undefined)
  }

  const onFetch = (file: File) => {
    setFile(file)
    setCurrentStep('preview')
  }

  return (
    <Drawer.Root {...rest}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent color="var(--light-100)" isSnappedTop>
            <Drawer.Top>
              <div>{currentStep === 'preview' && <Drawer.Back variant="ghost" onPress={onBack} position="left" />}</div>
              <Drawer.Title asChild>
                <span className={Styles.title}>Paste link</span>
              </Drawer.Title>
              <Drawer.Close label="Close" variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <div className={Styles.container}>
                {currentStep === 'pasteLink' && (
                  <PasteLink accept={accept} url={url} setUrl={setUrl} onFetch={onFetch} />
                )}
                {currentStep === 'preview' && file && <PreviewFile file={file} onUse={onUse} url={url} />}
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
